import { createContext, useContext } from "react";
import type { FullscreenPreviewContextValue } from "@/interfaces/CampaignBuilder";

// Lets the Landing preview's sticky filter header host the overlay's Exit control once pinned.
// `null` outside a provider because `RedemptionFilterBar` is shared with the real recipient flow.
// Exported raw, unlike the other contexts here: the overlay owns the state this value is built
// from, so a Provider wrapper would only pass those same fields straight through.

export const FullscreenPreviewContext = createContext<FullscreenPreviewContextValue | null>(null);

export function useFullscreenPreview(): FullscreenPreviewContextValue | null {
  return useContext(FullscreenPreviewContext);
}
